import { useEffect, useState } from 'react'
import type { CosmicVariationType } from '@/lib/cms/cosmic/types/CosmicProductType'
import { useGetShippingAddresses } from '@/lib/hooks/services/shippingAddresses/useGetShippingAddresses'
import { useShipByEstimation } from '@/lib/hooks/services/useShipByEstimation'
import type { HydraLines } from '@/lib/services/Hydra/account/GET/getSubscriptions'
import type { HydraGetSkuAvailabilityResponse } from '@/lib/services/Hydra/order/getSkuAvailability'
import useGlobalStore from '@/store/useGlobalStore'
import { DeliveringTo } from './DeliveringTo'
import { ProductAvailability } from './ProductAvailability'
import { ShipByEstimation } from './ShipByEstimation'

const ProductDelivery = ({
  selectedVariation,
  isLoadingProductAvailability,
  productAvailability,
}: {
  selectedVariation: CosmicVariationType | null
  isLoadingProductAvailability: boolean
  productAvailability: HydraGetSkuAvailabilityResponse | null
}) => {
  const {
    app: { marketExceptions },
  } = useGlobalStore()

  const { shipToOptions, isLoadingShipToOptions } = useGetShippingAddresses()
  const [activeLocation, setActiveLocation] = useState<number>(0)
  const [lines, setLines] = useState<Partial<HydraLines>>()

  const { shipByEstimation, isLoadingShipByEstimation } = useShipByEstimation({
    shipToAddress: shipToOptions
      ? shipToOptions[activeLocation]?.shipToAddress
      : undefined,
    lines,
  })

  useEffect(() => {
    // TODO: After cart is complete, we need to include the lines of the items in the cart
    setLines({
      items: [
        {
          item: {
            id: {
              unicity: selectedVariation?.pricing?.sku as string,
            },
            href: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/items?id.unicity=${selectedVariation?.pricing?.sku}`,
          },
          quantity: 1,
        },
      ],
    })
  }, [selectedVariation])

  if (!selectedVariation || !selectedVariation.sku) {
    return null
  }

  return (
    <div
      className="flex flex-col rounded-lg text-xs text-[#003764]"
      data-test="product-delivery"
    >
      {marketExceptions?.hasProductAvailability && (
        <ProductAvailability
          isLoadingProductAvailability={isLoadingProductAvailability}
          productAvailability={productAvailability}
          selectedVariation={selectedVariation}
        />
      )}
      {marketExceptions?.hasShipByDate && (
        <>
          <ShipByEstimation
            shipByEstimation={shipByEstimation}
            shipToOptions={shipToOptions}
            isLoadingShipByEstimation={isLoadingShipByEstimation}
            isLoadingShipToOptions={isLoadingShipToOptions}
          />
          <DeliveringTo
            isLoadingShipToOptions={isLoadingShipToOptions}
            shipToOptions={shipToOptions}
            activeLocation={activeLocation}
            setActiveLocation={setActiveLocation}
          />
        </>
      )}
    </div>
  )
}

export default ProductDelivery
